module.exports = __webpack_public_path__ + "cfd10af373bcb3e6ae793f4fc840d573.png";